import * as Yup from "yup";

export const schema = Yup.object().shape({
	startDate: Yup.string().nullable(),
	endDate: Yup.string().nullable(),
});

interface FormValues {
	startDate?: string | null;
	endDate?: string | null;
}

export const initialValues: FormValues = {
	startDate: null,
	endDate: null,
};
